/* 🤖 this file was generated by script */
export const wsolidiconPaperclip = {
  name: 'paperclip',
  data: `<svg viewBox="0 0 21 22"><path fill="currentColor" fill-rule="evenodd" d="M15.97 3.18a2.5 2.5 0 0 0-3.53 0L3.42 12.2a4.25 4.25 0 1 0 6.01 6l9.02-9a1 1 0 1 1 1.41 1.4l-9.02 9.02a6.25 6.25 0 0 1-8.83-8.84l9.01-9.01a4.5 4.5 0 0 1 6.37 6.36L8.72 16.8a2.75 2.75 0 1 1-3.89-3.89l7.6-7.6a1 1 0 1 1 1.42 1.42l-7.6 7.6a.75.75 0 1 0 1.06 1.06l8.66-8.66a2.5 2.5 0 0 0 0-3.54" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
